import { withShowIf } from "../../../with-show-if/with-show-If.component";
import styled from "@emotion/styled";
import Button from "@material-ui/core/Button";
import { units } from "../../../../types/units";
import { OutlinedButtonProps } from "./outlined-button.props";

export const OutlinedButton = withShowIf(styled(Button)`
  justify-content: start;
  padding: 1rem 2rem;
  border: 1px solid;
  max-height: ${(props: OutlinedButtonProps) => (props.small ? "40px" : "auto")};
  ${units({
    fontSize: "large",
    fontWeight: "bold",
    borderColor: "grey",
    "&.hover": {
      backgroundColor: "lynxWhite",
      boxShadow: "0 8px 5px rgba(0, 0, 0, 0.16)",
    },
  })};

  &.Mui-disabled {
    .MuiButton-startIcon {
      opacity: 0.25;
    }
  }
`);
